export default {
    spacer: {
        height: 5
    } as React.CSSProperties,
    antiSpacer: {
        marginTop: -20
    } as React.CSSProperties,
    fakeLabel: {
        fontSize: 12,
        color: 'rgb(184, 156, 160)'
    } as React.CSSProperties,
    noPageBreak: {
        pageBreakInside: "avoid", 
        paddingTop: 30, 
        marginTop: -30
    } as React.CSSProperties,
    
    // PRINTED FORM STYLES

    printedFormContainer: {
        width: "100%",
        height: "100%"
    } as React.CSSProperties,
    printedFormSection: {
        display: "flex",
        paddingLeft: 40,
        justifyContent: "flex-start",
        flexDirection: "row"
    } as React.CSSProperties,
    printedFormColumn: {
        width: "45%"
    } as React.CSSProperties,

    //HEADER
    printedFormTitle: {
        width: "100% - 80px",
        display: "flex",
        flexDirection: "column",
        fontSize: "1.25rem",
        fontWeight: 700,
        marginTop: -30,
        paddingBottom: 20,
        paddingLeft: 40,
        paddingRight: 40,
    } as React.CSSProperties,
    printedFormComplaintType: {
        textAlign: "center",
        marginTop: 30,
    } as React.CSSProperties,
    printedFormCompanyLogo: {
        marginTop: 10,
        marginRight: 10,
        maxWidth: 100,
        maxHeight: 50,
        filter: "grayscale(100%)"
    } as React.CSSProperties,

    // CUSTOMER
    printedFormRow: {
        display: "flex",
        flexDirection: "column",
        paddingBottom: 5,
    } as React.CSSProperties,
    printedFormFieldHeader: {
        color: "gray",
        fontWeight: 700,
        fontSize: "0.7rem"
    } as React.CSSProperties,
    printedFormField: {
        pageBreakInside: "avoid",
    } as React.CSSProperties,

    // DETAILS
    printedFormDetailsSection: {
        paddingLeft: 40,
        paddingRight: 40,
    } as React.CSSProperties,

    // ADMIN
    printedFormAdminRow: {
        display: "flex",
        paddingBottom: 5,
    } as React.CSSProperties,
    printedFormAdminField: {
        flex: 2
    } as React.CSSProperties,
    printedFormAdminHeader: {
        flex: 1,
        fontWeight: 700,
    } as React.CSSProperties,

    // DIVIDER
    printedFormDivider: {
        display: "flex",
        flexDirection: "row",
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 40,
        marginRight: 40,
    } as React.CSSProperties,
    printedFormDividerLineLeft: {
        marginTop: 13,
        flex: 1,
        borderTop: "2px solid lightgray",
    } as React.CSSProperties,
    printedFormSectionTitle: {
        paddingLeft: 10,
        paddingRight: 10,
        fontSize: "1.25rem",
        fontWeight: 700,
    } as React.CSSProperties,
    printedFormDividerLineRight: {
        marginTop: 13,
        flex: 10,
        borderTop: "2px solid lightgray",
    } as React.CSSProperties,

    // FOOTER
    printedFormFooter1: {
        fontSize: "0.7rem",
        position: "fixed",
        bottom: 24,
        right: 10,
    } as React.CSSProperties,
    printedFormFooter2: {
        fontSize: "0.7rem",
        position: "fixed",
        bottom: 10,
        right: 10,
    } as React.CSSProperties,
};